export default "__VITE_ASSET__DYr5t4bX__"